import BannerList from "./BannerList.container";

export default BannerList;
